import Modal from '../ui/Modal';
import Button from '../ui/Button';
import PlanPhoto from './PlanPhoto';
import { DataRow } from '../ui/MobileCard';
import { formatCurrency, formatDuration, formatRoi } from '../../lib/formatPlan';

/**
 * GET /investor/investment-plans/{uuid} detail view. `canManage` gates Edit/Delete
 * (manage-investment-plans — admin + super-admin); `showSubscribe` renders
 * a disabled "Subscribe" button instead of building a real subscribe flow,
 * since no endpoint exists for investor participation yet.
 */
export default function PlanDetailModal({ plan, onClose, canManage, onEdit, onDelete, showSubscribe }) {
  return (
    <Modal open={!!plan} onClose={onClose} title={plan?.name || 'Plan details'}>
      {plan && (
        <div className="space-y-4">
          <PlanPhoto src={plan.photo_url} alt={plan.name} className="h-48 w-full rounded-xl" />

          {plan.description && <p className="text-sm text-foreground-muted whitespace-pre-line">{plan.description}</p>}

          <div className="grid grid-cols-2 gap-x-4 gap-y-2">
            <DataRow label="Minimum" value={formatCurrency(plan.minimum_amount)} />
            <DataRow label="Maximum" value={plan.maximum_amount != null ? formatCurrency(plan.maximum_amount) : 'No cap'} />
            <DataRow label="ROI" value={formatRoi(plan.roi_percentage)} />
            <DataRow label="Duration" value={formatDuration(plan.duration_in_days)} />
          </div>

          <div className="flex flex-wrap gap-2 pt-3 border-t border-border">
            {showSubscribe && (
              <Button variant="secondary" size="sm" disabled title="Investor subscriptions aren't live yet.">
                Subscribe — coming soon
              </Button>
            )}
            {canManage && (
              <>
                <Button variant="ghost" size="sm" onClick={() => onEdit(plan)}>
                  Edit
                </Button>
                <Button variant="danger" size="sm" onClick={() => onDelete(plan)}>
                  Delete
                </Button>
              </>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
}
